import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import * as locations from '../../../../constants/dropdown';

import {messageTextValidation, nameValidation, emailValidation, phoneValidation} from '../../../../utils/itemValidation';
import {displayPhoneInput} from '../../../../utils/formatting';

import * as commonActionCreators from '../../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

import RhinoSelect from '../../../common/inputs/RhinoSelect';

class ScheduleShoppingForm extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

    const firstEntry = [{display: 'Select a Location*', 'value': ''}];
    const finalEntry = [{display: 'Virtual/Other', 'value': 'online@diamondsdirect.com'}];

    let newArray= firstEntry.concat(locations.locations).concat(finalEntry);

		this.state = {

      locations: newArray,

      inputFirstName: '',
      inputLastName: '',
      inputShopPreviously: '',
      inputSalesAssociate: '',
      inputLocation: '',
      inputShoppingFor: new Map(),
      inputDetails: '',
      inputContactPhone: '',
      inputContactEmail: '',

      errorFirstName: false,
      errorLastName: false,
      errorShopPreviously: false,
      errorSalesAssociate: false,
      errorLocation: false,
      errorShoppingFor: false,
      errorDetails: false,
      errorContactPhone: false,
      errorContactEmail: false,

      timeData: [
        {display: 'Time*', 'value': ''},
        {display: '10am - 12pm', 'value': '10am - 12pm'},
        {display: '1pm - 3pm', 'value': '1pm - 3pm'},
        {display: '4pm - 7pm', 'value': '4pm - 7pm'},
      ],

      dayOpen: false,
      dayValue: '',

      timeOpen: false,
      timeValue: '',
    }

    this.checkDayClick = ::this.checkDayClick;
    this.checkTimeClick = ::this.checkTimeClick;
	}

  componentDidMount() {
    document.addEventListener('click', this.checkDayClick, false);
    document.addEventListener('click', this.checkTimeClick, false);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.checkDayClick, false);
    document.removeEventListener('click', this.checkTimeClick, false);
  }

  checkDayClick(evt) {
    if(this.state.dayOpen === true) {

      console.log('checking day');

      let targetElement = evt.target;
      do {
          if(targetElement === this.dayBody) {
              return;
          }
          targetElement = targetElement.parentNode;
      } while (targetElement);
      this.setState({ dayOpen: false });
    }  
  }

  checkTimeClick(evt) {
    if(this.state.timeOpen === true) {
      let targetElement = evt.target;
      do {
          if(targetElement === this.timeBody) {
              return;
          }
          targetElement = targetElement.parentNode;
      } while (targetElement);
      this.setState({ timeOpen: false });
    }  
  }

  newTabNav(page) {
  	let win = window.open(page, '_blank');
    win.focus();
  }

  externalNav(page) {
    window.location.href = '/' + page;
  }

  internalNav(page) {
  	this.context.router.push('/' + page);
  }

  changeFirstName(evt) { 
    this.setState({ inputFirstName: evt.target.value }, () => {
      if(this.state.errorFirstName && !nameValidation(this.state.inputFirstName)) {
        this.setState({ errorFirstName: false });
      }
    });
  }

  changeLastName(evt) { 
    this.setState({ inputLastName: evt.target.value }, () => {
      if(this.state.errorLastName && !nameValidation(this.state.inputLastName)) {
        this.setState({ errorLastName: false });
      }
    });
  }

  changeShopPreviously(evt) { 
    this.setState({ inputShopPreviously: evt.target.value }, () => {
      if(this.state.errorShopPreviously) {
        this.setState({ errorShopPreviously: false });
      }
    });
  }

  changeSalesAssociate(evt) { 
    this.setState({ inputSalesAssociate: evt.target.value }, () => {
      if(this.state.errorSalesAssociate && !nameValidation(this.state.inputSalesAssociate)) {
        this.setState({ errorSalesAssociate: false });
      }
    });
  }

  changeLocation(evt) { 
    this.setState({inputLocation: evt.target.value}, () => {
      if(this.state.errorLocation !== false && location !== '') {
        this.setState({errorLocation: false});
      }
    });
  }

  changeShoppingFor(evt) { 
    const item = evt.target.name;
    const isChecked = evt.target.checked;
    this.setState(prevState => ({ inputShoppingFor: prevState.inputShoppingFor.set(item, isChecked) }));
  }

  changeDetails(evt) { 
    this.setState({ inputDetails: evt.target.value }, () => {
      if(this.state.errorDetails && !messageTextValidation(this.state.inputDetails)) {
        this.setState({ errorDetails: false });
      }
    });
  }

  changeContactPhone(evt) { 
    this.setState({ inputContactPhone: displayPhoneInput(evt.target.value) }, () => {
      if(this.state.errorContactPhone && !phoneValidation(this.state.inputContactPhone)) {
        this.setState({ errorContactPhone: false });
      }
    });
  }

  changeContactEmail(evt) { 
    this.setState({ inputContactEmail: evt.target.value }, () => {
      if(this.state.errorContactEmail && !emailValidation(this.state.inputContactEmail)) {
        this.setState({ errorContactEmail: false });
      }
    });
  }

  validateLocation() {

  }

  validateFirstName(evt) {
    this.setState({
      errorFirstName: nameValidation(evt.target.value) !== null,
    });
  }

  validateLastName(evt) {
    this.setState({
      errorLastName: nameValidation(evt.target.value) !== null,
    }); 
  }

  validateEmailInput(evt) {
    console.log(emailValidation(evt.target.value));
    this.setState({
      errorContactEmail: emailValidation(evt.target.value) !== null,
    });
  }

  validatePhoneInput(evt) {
    this.setState({
      errorContactPhone: phoneValidation(evt.target.value) !== null,
    });
  }

  toggleDay() {
    this.setState({ dayOpen: !this.state.dayOpen });
  }

  selectDay(clickVal) {
    let val = clickVal + ',';

    if(this.state.dayValue.includes(val)) {
      let current = this.state.dayValue;
      let newVal = current.split(val).join('');
      this.setState({dayValue: newVal});
    } else {
      this.setState({dayValue: this.state.dayValue + val});
    }
  }

  toggleTime() {
    this.setState({ timeOpen: !this.state.timeOpen });
  }

  selectTime(clickVal) {
    let val = clickVal + ',';

    if(this.state.timeValue.includes(val)) {
      let current = this.state.timeValue;
      let newVal = current.split(val).join('');
      this.setState({timeValue: newVal});
    } else {
      this.setState({timeValue: this.state.timeValue + val});
    }
  }

  validateAll() {

    let locationError = this.state.inputLocation === '';
    let previousError = this.state.inputShopPreviously === '';
    let firstNameError = nameValidation(this.state.inputFirstName) !== null;
    let lastNameError = nameValidation(this.state.inputLastName) !== null;
    let emailError = emailValidation(this.state.inputContactEmail) !== null;
    let phoneError = phoneValidation(this.state.inputContactPhone) !== null;
    
    this.setState({
      errorFirstName: firstNameError,
      errorLastName: lastNameError,
      errorShopPreviously: previousError,
      errorSalesAssociate: false,
      errorLocation: locationError,
      errorShoppingFor: false,
      errorDetails: false,
      errorContactPhone: phoneError,
      errorContactEmail: emailError,
    });

    return !locationError && !previousError && !firstNameError && !lastNameError && !emailError && !phoneError;
  }

  submitContactRequest() {
    if(this.validateAll()) {

      console.log(this.state.inputShoppingFor);
      console.log(JSON.stringify(this.state.inputShoppingFor));

      let shoppingFor = "";
      this.state.inputShoppingFor.forEach((value, key, map) => {
        if(value) {
          if(shoppingFor === "") {
            shoppingFor = key;
          } else {
            shoppingFor += ("," + key);
          }
        }
      });

      let shoppingData = {
        location_email: this.state.inputLocation,
        previous_bool: this.state.inputShopPreviously,
        first_name: this.state.inputFirstName,
        last_name: this.state.inputLastName,
        email: this.state.inputContactEmail,
        phone: this.state.inputContactPhone,
        associate: this.state.inputSalesAssociate,
        shopping_for: shoppingFor,
        message: this.state.inputDetails,
        apptDays: this.state.dayValue,
        apptTime: this.state.timeValue,
      }

      this.props.commonShoppingRequest(shoppingData);
      this.props.commonAlert('Thank you for submitting an appointment request! A member of our Customer Care Team will follow up with you shortly to finalize your appointment.', 'Continue Shopping', 'visit', '');
      this.setState({
        inputFirstName: '',
        inputLastName: '',
        inputShopPreviously: '',
        inputSalesAssociate: '',
        inputLocation: '',
        inputShoppingFor: new Map(),
        inputDetails: '',
        inputContactPhone: '',
        inputContactEmail: '',

        dayValue: '',
        timeValue: '',

        errorFirstName: false,
        errorLastName: false,
        errorShopPreviously: false,
        errorSalesAssociate: false,
        errorLocation: false,
        errorShoppingFor: false,
        errorDetails: false,
        errorContactPhone: false,
        errorContactEmail: false,
      });
    }
  }

  formatList(list) {
    if(!list) {
      return '';
    }
    let res = list.replace(/,/g, ', ');
    return res.trim().slice(0, -1);
  }

	render() {
		return <div className='ScheduleShoppingForm'>
      <div className='closeContact' onClick={::this.props.closeMethod}>
        <div className='closeX'>&times;</div>
      </div>
			<div className='formHeader'>Request a Shopping Appointment</div>
      <div className='formBody'>
        
        <div className='formRow'>
          <div className='oneHalfSection'>
            <RhinoSelect
              selectClass={'scheduleSelect'}
              required={true}
              options={this.state.locations}
              changeMethod={(evt) => this.changeLocation(evt)}
              value={this.state.inputLocation}
              error={this.state.errorLocation} />
          </div>
          <div className='oneHalfSection'>
            <div className={this.state.errorShopPreviously ? 'radioYesNoLabel error' : 'radioYesNoLabel'}>Have you shopped with us previously?&#42;</div>
            <div className='radioInputRow'>
              <div className='radioInputWrapper'>
                <div className='radioInputElement'>
                  <input 
                    className={this.state.errorShopPreviously ? 'radioInput error' : 'radioInput'}
                    type='radio'
                    name='radioShopPreviously'
                    value={'Yes'}
                    checked={this.state.inputShopPreviously === 'Yes'}
                    onClick={::this.changeShopPreviously} />
                </div>
                <div className='radioLabel'>Yes</div>
              </div>
              <div className='radioInputWrapper'>
                <div className='radioInputElement'>
                  <input 
                    className={this.state.errorShopPreviously ? 'radioInput error' : 'radioInput'}
                    type='radio'
                    name='radioShopPreviously'
                    value={'No'}
                    checked={this.state.inputShopPreviously === 'No'}
                    onChange={::this.changeShopPreviously} />
                </div>
                <div className='radioLabel'>No</div>
              </div>
            </div>
            <div className={this.state.inputShopPreviously === 'Yes' ? 'expandableHalfSection open' : 'expandableHalfSection'}>
              <input 
                className={this.state.errorSalesAssociate ? 'textInput error' : 'textInput'}
                type='text' 
                placeholder='Your Sales Associate?'
                value={this.state.inputSalesAssociate}
                onChange={::this.changeSalesAssociate} />
            </div>
          </div>
        </div>

        <div className='formRow'>
          <div className='formSubheader'>Your Contact Information</div>
          <div className='oneHalfSection'>
            <input 
              className={this.state.errorFirstName ? 'textInput error' : 'textInput'}
              type='text' 
              placeholder='First Name&#42;'
              value={this.state.inputFirstName}
              onChange={::this.changeFirstName}
              onBlur={::this.validateFirstName} />
          </div>
          <div className='oneHalfSection'>
            <input 
              className={this.state.errorLastName ? 'textInput error' : 'textInput'}
              type='text' 
              placeholder='Last Name&#42;'
              value={this.state.inputLastName}
              onChange={::this.changeLastName}
              onBlur={::this.validateLastName} />
          </div>
        </div>

        <div className={'formRow preBanner'}>
          <div className='oneHalfSection'>
            <input 
              className={this.state.errorContactEmail ? 'textInput error' : 'textInput'}
              type='email' 
              placeholder='Email&#42;'
              value={this.state.inputContactEmail}
              onChange={::this.changeContactEmail}
              onBlur={::this.validateEmailInput}  />
          </div>
          <div className='oneHalfSection'>
            <input 
              className={this.state.errorContactPhone ? 'textInput error' : 'textInput'}
              type='tel' 
              placeholder='Phone&#42;'
              value={this.state.inputContactPhone}
              onChange={::this.changeContactPhone}
              onBlur={::this.validatePhoneInput}  />
          </div>
        </div>



        <div className={'formRow emRow'}>
          <div className='shoppingForLabelWrapper'>
            <div className='shoppingForPrimary'>I'm shopping for:</div>
            <div className='shoppingForSecondary'>(check all that apply)</div>
          </div>
          <div className='shoppingForBodyWrapper'>
            <div className='checkboxInputWrapper'>
              <div className='checkboxInputElement'>
                <input 
                  className={'checkboxInput'}
                  type='checkbox'
                  name='Engagement Ring'
                  checked={this.state.inputShoppingFor.get('Engagement Ring')}
                  onChange={::this.changeShoppingFor} />
              </div>
              <div className='checkboxLabel'>Engagement Ring</div>
            </div>
            <div className='checkboxInputWrapper'>
              <div className='checkboxInputElement'>
                <input 
                  className={'checkboxInput'}
                  type='checkbox'
                  name='Wedding Bands'
                  checked={this.state.inputShoppingFor.get('Wedding Bands')}
                  onChange={::this.changeShoppingFor} />
              </div>
              <div className='checkboxLabel'>Wedding Bands</div>
            </div>


            <div className='checkboxInputWrapper'>
              <div className='checkboxInputElement'>
                <input 
                  className={'checkboxInput'}
                  type='checkbox'
                  name='Upgrade/Trade-in'
                  checked={this.state.inputShoppingFor.get('Upgrade/Trade-in')}
                  onChange={::this.changeShoppingFor} />
              </div>
              <div className='checkboxLabel'>Upgrade/Trade-in</div>
            </div>
            <div className='checkboxInputWrapper'>
              <div className='checkboxInputElement'>
                <input 
                  className={'checkboxInput'}
                  type='checkbox'
                  name='Fine jewelry'
                  checked={this.state.inputShoppingFor.get('Fine jewelry')}
                  onChange={::this.changeShoppingFor} />
              </div>
              <div className='checkboxLabel'>Fine Jewelry</div>
            </div>
            <div className='checkboxInputWrapper'>
              <div className='checkboxInputElement'>
                <input 
                  className={'checkboxInput'}
                  type='checkbox'
                  name='Lab Grown'
                  checked={this.state.inputShoppingFor.get('Lab Grown')}
                  onChange={::this.changeShoppingFor} />
              </div>
              <div className='checkboxLabel'>Lab Grown Diamonds</div>
            </div>
          </div>
        </div>
        <div className={'formRow'}>
          <div className={'shoppingForLabelWrapper lightBg'}>
            <div className='shoppingForPrimary'>Preferred Appointment Day &amp; Time</div>
            <div className='shoppingForSecondary'>(select all that apply)</div>
          </div>
          <div className='shoppingForBodyWrapper'>
            <div className='timeElement'>
              <div className='timeWrapper' ref={(div) => { this.dayBody = div; }}>
                <div className={'dropElement EllipsisElement'} onClick={::this.toggleDay}>
                  {this.state.dayValue && !this.state.dayOpen ? this.formatList(this.state.dayValue) : 'Select Day'}
                </div>
                <div className={this.state.dayOpen ? 'expandSection expanded' : 'expandSection'}>
                  <div className={this.state.dayValue.includes('Monday') ? 'dropElement selected' : 'dropElement'} onClick={() => this.selectDay('Monday')}>Monday</div>
                  <div className={this.state.dayValue.includes('Tuesday') ? 'dropElement selected' : 'dropElement'} onClick={() => this.selectDay('Tuesday')}>Tuesday</div>
                  <div className={this.state.dayValue.includes('Wednesday') ? 'dropElement selected' : 'dropElement'} onClick={() => this.selectDay('Wednesday')}>Wednesday</div>
                  <div className={this.state.dayValue.includes('Thursday') ? 'dropElement selected' : 'dropElement'} onClick={() => this.selectDay('Thursday')}>Thursday</div>
                  <div className={this.state.dayValue.includes('Friday') ? 'dropElement selected' : 'dropElement'} onClick={() => this.selectDay('Friday')}>Friday</div>
                  <div className={this.state.dayValue.includes('Saturday') ? 'dropElement selected' : 'dropElement'} onClick={() => this.selectDay('Saturday')}>Saturday</div>
                </div>
              </div>
            </div>
            <div className='timeElement'>
              <div className='timeWrapper' ref={(div) => { this.timeBody = div; }}>
                <div className={'dropElement EllipsisElement'} onClick={::this.toggleTime}>
                  {this.state.timeValue && !this.state.timeOpen ? this.formatList(this.state.timeValue) : 'Select Time'}
                </div>
                <div className={this.state.timeOpen ? 'expandSection expanded' : 'expandSection'}>
                  <div className={this.state.timeValue.includes('Morning') ? 'dropElement selected' : 'dropElement'} onClick={() => this.selectTime('Morning')}>Morning</div>
                  <div className={this.state.timeValue.includes('Afternoon') ? 'dropElement selected' : 'dropElement'} onClick={() => this.selectTime('Afternoon')}>Afternoon</div>
                  <div className={this.state.timeValue.includes('Evening') ? 'dropElement selected' : 'dropElement'} onClick={() => this.selectTime('Evening')}>Evening</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={'formRow darkBg'}>
          <div className='textareaLabelWrapper'>Additional Details:</div>
          <div className='textareaInputWrapper'>
            <textarea
              className={this.state.errorDetails ? 'textTextarea error' : 'textTextarea'}
              value={this.state.inputDetails}
              onChange={::this.changeDetails}>
            </textarea>
          </div>
        </div>
        <div className={'formRow darkBg bottomRow'}>
          <div className={'submitButton actionButton'} onClick={::this.submitContactRequest}>Request an Appointment</div>
        </div>
      </div>
		</div>;
	}
}
export default ScheduleShoppingForm;

function mapStateToProps(state) {
  return {

  };
}

export const ScheduleShoppingFormContainer = connect(
  mapStateToProps,
  allActionCreators
)(ScheduleShoppingForm);


// WEBPACK FOOTER //
// ./src/components/views/scheduleappointment/components/ScheduleShoppingForm.jsx